App.Models.VenueStatistics = BackboneEx.Model.Base.extend({
  lastFetchedVenueId: null,

  url: function () {
    return App.Api.wsUrl('/venue/' + App.getVenueId() + '/statistics.json');
  },
});
